import { Component } from '@angular/core';


@Component({
  selector: 'BackgroundGradient',
  standalone: true,
  imports: [],
  template: `
    <div class="absolute left-0 top-0 w-full h-screen max-h-full bg-gradient-to-b from-white to-blue-50 z-0"></div>
  `
})
export class BackgroundGradient {
}
